/**
 * @file poTransportLock.js
 * @version 1.1.0
 * @author Cam Seymour
 * @project Excel Agri System
 * @created 2026-10-12
 * @modified 2026-10-13
 * @description Is a purchase order raised for a customer order?
 *
 *   1.1.0 (2026-10-13): WHEN a PO's haulier, driver and vehicle are the
 *   planning board's to set is now utils/transportLock.js — one rule for the
 *   PO editor, Add / Update Supplied Qty and the boards (Cam, 13 Oct:
 *   "locked to transport planning only until the day it is delivered"). This
 *   file keeps only poHasCustomerOrder.
 *
 *   "Has a customer order": its customer_order_id, an order line it is bought
 *   on (the server's linked orders), or a PO line bought for an order line.
 *
 *   The server's utils/poTransportLock.js is GENERATED from this file by
 *   scripts/sync-shared-utils.js — edit this one and re-run it.
 */

/**
 * Is this PO raised for a customer order?
 * @param {{ customerOrderId?, linkedOrderCount?: number, lines?: Array }} p
 *   lines: PO lines in either shape — `orderLineId` (the PO's JSON and the
 *   grid), or a PO-H's `sourceOrderLineId` / a haulage line's
 *   `haulageForOrderLineId`.
 */
export function poHasCustomerOrder({ customerOrderId = null, linkedOrderCount = 0, lines = [] } = {}) {
  if (customerOrderId) return true;
  if (Number(linkedOrderCount) > 0) return true;
  return (Array.isArray(lines) ? lines : []).some(l => !!l
    && !!(l.orderLineId || l.sourceOrderLineId || l.haulageForOrderLineId));
}
